import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
// import { createTreeCategories, treeForSelect } from '@/helpers/tree'
import { apiAxios } from '@/helpers'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'categories',
    model: 'category',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      name: [],
      abbreviation: '',
      parentCategory: '',
      matchesDuration: 90,
      order: '',
      startAt: '',
    },
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
}

const actions = {
  ...baseActions,
  async create({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/create', payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList', { only: 1, limit: 0 })
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async fetchList({ commit, state }, params = {}) {
    let set = true
    if (params.set === false) {
      set = false
      delete params.set
    }
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }
    if (state.pagination.sortBy) {
      query.sort = {
        [state.pagination.sortBy]: state.pagination.descending ? -1 : 1,
      }
      delete body.page
    }
    if (state.selected.active !== undefined) body.active = 'all'
    if (state.filters && typeof state.filters === 'object') {
      Object.keys(state.filters).forEach((key) => {
        if (state.filters[key] !== '' && state.filters[key] !== undefined) {
          body[key] = state.filters[key]
        }
      })
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setList', list)
    return list
  },
  async categoryRoot({ commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${id}/root`)
      .finally(() => commit('setLoading', false))
    const item = data.data ? data.data[state.model] : []
    return item || []
  },
  async update({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const id = payload._id
    const { data } = await apiAxios
      .put(`${state.module}/${id}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList', { only: 1, children: true, limit: 0 })
    const item = data.data ? data.data[state.model] : {}
    return item
  },
  async delete({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .delete(`${state.module}/${id}`)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList', { only: 1, limit: 0 })
  },
  async updateCategory({ commit }, info) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`categories-year/change-one`, info)
      .finally(() => commit('setLoading', false))

    return data
  },
}

const mutations = {
  ...baseMutations,
  setList(state, payload) {
    state.list = []
    if (Array.isArray(payload)) payload.forEach((item) => state.list.push(item))
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
